export default __webpack_public_path__ + "static/media/logo.82ba22a6.png";